import { createFileRoute } from "@tanstack/react-router";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { DmedView } from "@/client/modules/financeiro/dmed/dmed-view";
import Loading from "@/client/modules/financeiro/dmed/loading";

export const Route = createFileRoute("/app/financeiro/dmed")({
  validateSearch: (s: Record<string, unknown>): { ano?: string } => ({ ano: s.ano as string | undefined }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => ensurePage(context.queryClient, apiQuery("financeiro", "dmedPage", deps)),
  head: () => pageHead("DMED"),
  pendingComponent: Loading,
  component: DmedPage,
});

function DmedPage() {
  const search = Route.useSearch();
  const { data } = useApiSuspenseQuery("financeiro", "dmedPage", search);
  return <DmedView {...data} />;
}
